<template>
    <ListenerGenreDetails v-if="isListenerMobile" />
    <GenreDetails v-else />
</template>

<script>
import GenreDetails from './GenreDetails.vue'
import ListenerGenreDetails from './ListenerGenreDetails.vue'

export default {
    name: 'GenreDetailsEntry',
    components: {
        GenreDetails,
        ListenerGenreDetails
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
